const postToParent = (action, data) => {
  if (window.parent) {
    window.parent.postMessage({ action, data }, '*')
  }
}

const postToNative = (payload) => {
  if (window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(JSON.stringify(payload))
  }
}

export const bridge = {
  gotoGamesHub: () => {
    postToParent(EVENTS.CLICK_GAMES_HUB, {})
  },

  signup: (data) => {
    postToParent(EVENTS.CLICK_SIGNUP, data)
  },

  callNativeRedirection: (url) => {
    if (url) {
      postToNative({
        action: 'bannerLinkRedirection',
        targetFunc: 'bannerLinkRedirection',
        type: 'link',
        url,
      })
    }
  },

  parentNavigation: (action, data = {}) => {
    if (!action) return
    // if (window.ReactNativeWebView) {
    //   postToNative({
    //     action: action || EVENTS.PARENT_NAVIGATION,
    //     data: data,
    //   })
    // } else {
    // }
    postToParent(action || EVENTS.PARENT_NAVIGATION, data)
  },

  sendMessageToApp: (action) => {
    if (typeof window === 'undefined' || !window.ReactNativeWebView) return
    try {
      window.ReactNativeWebView.postMessage(JSON.stringify(action))
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Failed to send message to app:', error, action)
    }
  },
}


export const EVENTS = {
  CLICK_GAMES_HUB: 'CLICK_GAMES_HUB',
  CLICK_SIGNUP: 'CLICK_SIGNUP',
  CLICK_LOGOUT: 'CLICK_LOGOUT',
  CLICK_NOTIFICATION: 'CLICK_NOTIFICATION',
  CLICK_WALLET: 'CLICK_WALLET',
  CLICK_PROFILE: 'CLICK_PROFILE',
  CLICK_BALANCE_UPDATE: 'CLICK_BALANCE_UPDATE',
  CLICK_INSUFFICIENT_FUNDS: 'CLICK_INSUFFICIENT_FUNDS',
  CLICK_TERMS: 'CLICK_TERMS',
  PARENT_NAVIGATION: 'parentNavigation',
  CLICK_CLEAR_SPOTLIGHT: 'CLICK_CLEAR_SPOTLIGHT',
}